<script setup lang="ts">
import { SearchMode } from '@utils/types';
import type { Radio } from '#imports';
import SearchReserveForm from '@components/util/search/SearchReserveForm.vue';
import { ReserveType } from '@utils/itinerary';

const { isChangeSearch, loading } = defineProps<{
    isChangeSearch?: boolean;
    loading?: boolean;
}>();
const layoutStore = useLayoutStore();
const { autoReserveInProcessCount } = classToRefs(layoutStore);
const busForm = useBusForm();
const form = useTripSearchForm(isChangeSearch);
const destinationListMessage = computed(() =>
    !form.origin.value ? 'ابتدا پایانه مبدا را انتخاب کنید.' : undefined
);
const busOptions = computed<Radio<SearchMode>[]>(() => [
    {
        label: 'داخلی',
        value: SearchMode.Domestic,
    },
    {
        label: 'خارجی',
        value: SearchMode.Foreign,
    },
]);
const formAlert = computed(() =>
    autoReserveInProcessCount.value
        ? {
              title: `${autoReserveInProcessCount.value} سفر در حال رهگیری برای رزرو خودکار`,
              href: '/panel/auto-reserve',
          }
        : undefined
);
onMounted(() => {
    if (!isChangeSearch && form.origin.value && !busForm.destinations.length) {
        busForm.loadDestinations();
        busForm.loadPrices();
    }
    if (!isChangeSearch) {
        layoutStore.getAutoReserveInProcessCount();
    }
});
watch(form.origin, () => busForm.loadDestinations());
</script>

<template>
    <SearchReserveForm
        v-bind="form"
        :loading
        :is-change-search
        :reserve-type="ReserveType.Bus"
        :empty-destination-message="destinationListMessage"
        origin-title="پایانه مبدأ"
        destination-title="پایانه مقصد"
        :search-mode-options="busOptions"
        :form-alert
    />
</template>
